<form class="example-form">
  <mat-form-field style="width: 500px" appearance="outline" class="-mb-6">
    <mat-label>Attributes List</mat-label>
    <mat-chip-grid
      #chipGrid
      [ngClass]="selectedOperands.length ? 'reduced-height' : ''"
      >
      @for (operand of selectedOperands; track operand) {
        <mat-chip-row
          (removed)="remove(operand)"
          >
          <em-operand-with-icon
            class="flex items-center"
            [operand]="operand"
            [isCustom]="isCustom(operand.value)"
          ></em-operand-with-icon>
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input
        placeholder="Add more..."
        #operandInput
        [formControl]="inputControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
        />
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selected($event)"
      >
      @for (property of filteredPredefinedProperties$ | async; track property) {
        <mat-option
          [value]="property"
          >
          <em-operand-with-icon
            [operand]="property"
            [isCustom]="false"
          ></em-operand-with-icon>
        </mat-option>
      }

      @if (filteredCustomProperties$ | async; as customProperties) {
        <mat-optgroup
          [label]="'SHARED_LABEL_CUSTOM_ATTRIBUTES' | translate"
          >
          @for (property of customProperties; track property) {
            <mat-option
              [value]="property"
              >
              <em-operand-with-icon
                [operand]="property"
                [isCustom]="true"
              ></em-operand-with-icon>
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
